import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["submitter"]

  submit() {
    if (this.hasSubmitterTarget) {
      this.element.requestSubmit(this.submitterTarget)
    } else {
      this.element.requestSubmit()
    }
  }
}
